import { Box, CircularProgress, Typography } from "@mui/material";
import { GetDailyReportAPI } from "api/reportApi";
import MDBox from "components/MDBox";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import RefundReportsTable from "./components/RefundReportsTable";
import TransactionReportTable from "./components/TransactionReportTable";

export default function DailyReport() {
  const { search } = useLocation();
  const reportId = new URLSearchParams(search).get("reportId");

  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!reportId) return;

    (async () => {
      try {
        setLoading(true);
        const res = await GetDailyReportAPI(reportId);
        if (res.data.success) setReport(res.data.report);
        else console.error(res.data.message);
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [reportId]);

  if (loading)
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress color="info" />
      </Box>
    );

  if (error)
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography color="error">{error}</Typography>
      </Box>
    );

  if (!report)
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography>No report found.</Typography>
      </Box>
    );

  const { reportType } = report;

  return (
    <MDBox sx={{ maxWidth: "100%", margin: "0 auto", padding: 2 }}>
      {reportType === "refund" ? (
        <RefundReportsTable report={report} />
      ) : (
        <TransactionReportTable report={report} />
      )}
    </MDBox>
  );
}
